import { SportMatchModel } from '@nf/types/odds';
import { ChannelModel } from './streaming.service';
import { SiteConfigsSettingsData } from '@nf/types/site';
import { UserInfo } from '@nf/types/account';

const supportStreamingSourceList = ['11', '13', '19'];
const supportStreamerSourceList = ['20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'];

type PluginSource = {
	sourceId: number,
	sourceName: string,
	enable?: boolean,
}

export const getMaskedStreamingSrc = (SiteConfigsData: SiteConfigsSettingsData | null | undefined, user: UserInfo | null | undefined) => {

	const pluginSources: Array<PluginSource> = [
		{
			sourceId: 11,
			sourceName: 'Glive',
			enable: SiteConfigsData?.CanSeeGLiverStreaming

		},
		{
			sourceId: 13,
			sourceName: 'InHouse',
			enable: true
		},
		{
			sourceId: 19,
			sourceName: 'CloudRock',
			enable: user?.CanSeeCloudRockStreaming

		},
		{
			sourceId: 30,
			sourceName: 'Streamer',
			enable: user?.LicenseeSiteSetting?.EnablePluginStreamerSources?.includes(30)
		},
		{
			sourceId: 31,
			sourceName: 'SlmtGV',
			enable: SiteConfigsData?.EnableSlmtGv
		}
	];

	return pluginSources.filter(source => !source.enable)
		.map(source => source.sourceId);		
}

const checkIsSupportSource = (
	channelList: ChannelModel[],
	match: SportMatchModel
) => {
	const isSupportSource = channelList.some(channel => {
		const src = channel.value.split('-')[0];
		return supportStreamingSourceList.includes(src)
			|| supportStreamerSourceList.includes(src);
	})

	if (isSupportSource) {
		return true;
	}

	return [1, 2].includes(match?.GameID);
}

const getSupportStreamerSourceList = () => supportStreamerSourceList;

export default {
	checkIsSupportSource: checkIsSupportSource,
	getSupportStreamerSourceList: getSupportStreamerSourceList,
	getMaskedStreamingSrc: getMaskedStreamingSrc
}